"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PixiWinCounter2 = void 0;
var _gsap = _interopRequireDefault(require("gsap"));
var _core = require("@dragon/core");
var _PixiAnimatedParticleEmitter = require("./particles/PixiAnimatedParticleEmitter");
var _pixiGame = require("@dragon/pixi-game");
var _PixiWinParticlesConstants = require("./particles/PixiWinParticlesConstants");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * Better more adaptable version of the PixiWinCounter
 */
var PixiWinCounter2 = exports.PixiWinCounter2 = /*#__PURE__*/function (_PixiGameComponent) {
  function PixiWinCounter2(componentName, style) {
    var _this;
    _classCallCheck(this, PixiWinCounter2);
    _this = _callSuper(this, PixiWinCounter2, [componentName]);
    _defineProperty(_this, "specialInterval", 0.04);
    /**
     * the Text, one being modified by the counter
     */
    _defineProperty(_this, "text", void 0);
    _defineProperty(_this, "_prevCoins", void 0);
    /**
     * Particle emitters for the coins or ruby showers.
     */
    _defineProperty(_this, "coinShowers", []);
    _defineProperty(_this, "_counterTween", void 0);
    _defineProperty(_this, "reset", function () {
      _this.text.text = (0, _core.coinsToCurrency)(0, undefined, undefined, undefined, undefined, true);
      _this._prevCoins = 0;
    });
    _defineProperty(_this, "resetPrevious", function () {
      _this._prevCoins = 0;
    });
    _defineProperty(_this, "hide", function () {
      var animate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var reset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      if (animate) {
        _gsap["default"].killTweensOf(_this.text);
        _gsap["default"].to(_this.text, {
          duration: 0.4,
          alpha: 0,
          onComplete: function onComplete() {
            if (reset) _this.reset();
          }
        });
      } else {
        _this.text.alpha = 0;
        if (reset) _this.reset();
      }
    });
    _defineProperty(_this, "show", function () {
      var animate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      //tODO reset???
      if (animate) {
        _gsap["default"].killTweensOf(_this.text);
        _gsap["default"].to(_this.text, {
          duration: 0.2,
          alpha: 1
        });
      } else _this.text.alpha = 1;
    });
    _defineProperty(_this, "set", function (coins) {
      _this.text.text = (0, _core.coinsToCurrency)(coins, undefined, undefined, undefined, undefined, true);
      _this._prevCoins = coins;
    });
    _defineProperty(_this, "hardSet", function (coins) {
      if (_this._counterTween) _this._counterTween.kill();
      _this.text.text = (0, _core.coinsToCurrency)(coins, undefined, undefined, undefined, undefined, true);
      _this._prevCoins = coins;
    });
    _this.width = 500;
    _this.height = 80;
    _this.alpha = 1;
    _this.visible = true;
    _this.text = new _pixiGame.CustomBitmapText('', style);
    _this.text.y = 0;
    _this.text.anchor.set(0.5, 0.5);
    _this.addChild(_this.text);
    return _this;
  }
  _inherits(PixiWinCounter2, _PixiGameComponent);
  return _createClass(PixiWinCounter2, [{
    key: "addCounterBackGround",
    value: function addCounterBackGround(dispObj) {
      this.text.addChildAt(dispObj, 0);
    }
  }, {
    key: "setCounter",
    value:
    /**
     * Start a count, will resolve promise on count complete.
     * @param coins 
     */
    function setCounter(coins) {
      var _this2 = this;
      var timeInSeconds = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0.3;
      // we count an object, for sake of gsap.
      var counter = {
        value: this._prevCoins
      };
      if (this._counterTween) this._counterTween.kill();
      this._prevCoins = coins;
      this._counterTween = _gsap["default"].to(counter, {
        duration: timeInSeconds,
        value: coins,
        ease: 'power1.out',
        onUpdate: function onUpdate() {
          _this2.text.text = (0, _core.coinsToCurrency)(counter.value, undefined, undefined, undefined, undefined, true);
        }
      });
      return this._counterTween;
    }

    /**
     * Add a coin shower, can have multiple showers.
     * 
     * @param showerConfig 
     * @param sprites 
     * @returns 
     */
  }, {
    key: "addShower",
    value: function addShower() {
      var showerConfig = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        "startRotation": {
          "min": 220,
          "max": 320
        },
        "acceleration": {
          "x": 0,
          "y": 1500
        }
      };
      var sprites = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _PixiWinParticlesConstants.GOLD_DOLLAR_COINS_SPRITES;
      var mobileShowerConfig = arguments.length > 2 ? arguments[2] : undefined;
      var coinShower = new _PixiAnimatedParticleEmitter.PixiAnimatedParticleEmitter(undefined, sprites, showerConfig, mobileShowerConfig);
      coinShower.position = this.position;
      coinShower.y = -40;
      this.addChildAt(coinShower, 0);
      this.coinShowers.push(coinShower);
      return coinShower;
    }
    /**
     * instantly stop all showers.
     */
  }, {
    key: "stopAllShowers",
    value: function stopAllShowers() {
      this.coinShowers.forEach(function (shower) {
        shower.stop();
      });
    }
  }, {
    key: "startAllShowers",
    value: function startAllShowers() {
      this.coinShowers.forEach(function (shower) {
        shower.start();
      });
    }
  }]);
}(_pixiGame.PixiGameComponent);
//# sourceMappingURL=PixiWinCounter2.js.map